import { AxiosInstance, AxiosResponse } from 'axios';
import ColisportApiResource from './colisport-api-resource.model';
import {
  InvoiceResponse,
  InvoiceSchemaBackend,
} from '../../components/Invoice/invoice-response.model';
import { DownloadMonthlyInvoice } from '../../models/download-monthly-invoice';
import { Invoice } from '../../models/invoice.model';

export interface BillingDocument {
  id: string;
  type:
    | 'shipment_invoice'
    | 'extra_invoice'
    | 'shipment_credit_note'
    | 'subscription_invoice'
    | 'subscription_credit_note';
  date: string;
  amountEuros: number | null;
  reference: string;
  downloadKey: string;
}

export interface BillingHistoryResponse {
  items: BillingDocument[];
  total: number;
  hasMore: boolean;
}

export default class InvoiceApi implements ColisportApiResource {
  readonly apiUrlPath = 'invoice';

  constructor(readonly httpClient: AxiosInstance) {}

  downloadInvoiceFile(downloadId: string): Promise<AxiosResponse<InvoiceResponse>> {
    return this.httpClient.get(`${this.apiUrlPath}/getinvoicedata/${downloadId}`);
  }

  findByColisportId(colisportId: string): Promise<AxiosResponse<InvoiceSchemaBackend>> {
    return this.httpClient.get(`${this.apiUrlPath}/colisportId/${colisportId}`);
  }

  downloadMonthlyInvoices(
    downloadMonthlyInvoice: DownloadMonthlyInvoice,
  ): Promise<AxiosResponse<ArrayBuffer>> {
    return this.httpClient.post(
      `${this.apiUrlPath}/getmonthlyinvoicedata`,
      downloadMonthlyInvoice,
      {
        responseType: 'arraybuffer',
      },
    );
  }

  getBillingHistory(
    email: string,
    page: number,
    limit: number,
  ): Promise<AxiosResponse<BillingHistoryResponse>> {
    return this.httpClient.get(`${this.apiUrlPath}/billing-history/${encodeURIComponent(email)}`, {
      params: { page, limit },
    });
  }

  downloadInvoicePdf(downloadId: string): Promise<AxiosResponse<ArrayBuffer>> {
    return this.httpClient.get(`${this.apiUrlPath}/download-pdf/${downloadId}`, {
      responseType: 'arraybuffer',
    });
  }

  generateInvoiceWithPriceId(
    colisportId: string,
    priceID: string,
    price: number,
    priceWithoutVat: number,
    vatValue: number,
    vatNumber: string,
    email: string,
  ): Promise<AxiosResponse<Invoice>> {
    return this.httpClient.post(`${this.apiUrlPath}/generate/extra`, {
      colisportId,
      priceID,
      price,
      priceWithoutVat,
      vatValue,
      vatNumber,
      email,
    });
  }
}
